/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Composable
import { createApp } from 'vue'

import { registerLayouts } from '@/layouts'

// Plugins
import { registerPlugins } from '@/plugins'

// Components
import App from './App.vue'
// Styles
import 'unfonts.css'

const app = window.app = createApp(App)

registerPlugins(app)

registerLayouts(app)

app.mount('#app')
